/**
 * Scroll Handling, Effects, and Animations
 *
 * This file was written to migrate scroll effects from Locomotive Scroll 4 to Lenis
 * If you are writing a new scroll.js file and using this as inspiration, I recommend using
 * a somewhat different structure as this is not all exactly necessary on a brand new Lenis project.
 */

import Odometer from "odometer";
import Lenis from "lenis";
import gsap from "gsap";
import Vivus from "vivus";

export const lenis = new Lenis({
	autoRaf: true,
	lerp: 0.15,
});

export const initScroll = () => {
	applyScrollAnimations(0);

	lenis.on("scroll", (e) => {
		applyScrollAnimations(e.scroll);
	});

	// I think I just did this in a rush, theres probably a better way than randomyl placing here.
	revealTextUpwards(".hidden-text");
};

const applyScrollAnimations = (scroll) => {
	const elements = document.querySelectorAll("[data-scroll]");
	elements.forEach((el) => {
		checkAnimNameAndTrigger(el, scroll);
	});
};

const checkAnimNameAndTrigger = (el, scroll) => {
	if (el.hasAttribute("data-scroll-speed") && window.innerWidth > 768) {
		applyParallax(el, scroll);
	}

	if (el.hasAttribute("data-scroll-call")) {
		const funct = el.getAttribute("data-scroll-call");
		const obj = {
			el: el,
		};
		// if the mapped item doesn't exist, return. (defined at bottom of file)
		if (!callAnimMap[funct]) return;
		let triggerValue = el.getBoundingClientRect().top + window.scrollY;

		if (el.hasAttribute("data-scroll-offset")) {
			triggerValue += parseInt(el.getAttribute("data-scroll-offset"));
		}

		// if the element is in the viewport, call the function
		if (!el.hasAttribute("data-scroll-triggered") && triggerValue < window.innerHeight + window.scrollY) {
			callAnimMap[funct](null, null, obj);
			el.setAttribute("data-scroll-triggered", true);
		}
	}
};

const applyParallax = (el, scroll) => {
	// let triggerValue = el.getBoundingClientRect().top + window.scrollY;
	let triggerValue = el.getBoundingClientRect().top + scroll;
	const sensitivity = 0.5;
	const speed = el.getAttribute("data-scroll-speed");
	const offset = el.getAttribute("data-scroll-offset") || 0;

	// const elementInitialPos = el.getBoundingClientRect().top + window.scrollY;
	const elementInitialPos = el.getBoundingClientRect().top - 250 + scroll;
	// const scrollFromElement = window.scrollY - elementInitialPos;
	const scrollFromElement = scroll - elementInitialPos;

	const scrollSpeedSensitivity = sensitivity / 10;
	const speedTranslateValue = scrollFromElement * speed * scrollSpeedSensitivity * -1 + offset;

	// const windowTopBoundary = window.scrollY - window.innerHeight - offset;
	const windowTopBoundary = scroll - window.innerHeight - offset;
	// const windowBottomBoundary = window.scrollY + window.innerHeight + offset;
	const windowBottomBoundary = scroll + window.innerHeight + offset;
	const isInView = triggerValue > windowTopBoundary && triggerValue < windowBottomBoundary;

	if (isInView) {
		el.style.transform = `translateY(${speedTranslateValue}px)`;
	}
};

const fadeUp = (func, direction, obj) => {
	// check if element has a data-scroll-delay attribute
	const delay = obj.el.dataset.scrollDelay || 0;
	obj.el.style.transitionDelay = `${delay}ms`;
	obj.el.classList.add("fade-up");
};

const statFadeUp = (func, direction, obj) => {
	// svg icon draw animation
	const svg = obj.el.querySelector("svg.stat-icon");
	const id = svg.id;
	new Vivus(id, { start: "manual", type: "sync", duration: 200 }, function (obj) {
		obj.el.classList.add("finished");
	}).play();

	// number odometer anim
	const detail = obj.el.querySelector(".odometer");
	var od = new Odometer({
		el: detail,
		value: 0,
		duration: 200,
		format: "",
		theme: "minimal",
	});
	od.update(detail.dataset.statNumberValue);
};

const quickOdometer = (func, direction, obj) => {
	const detail = obj.el.querySelector(".odometer");
	var od = new Odometer({
		el: detail,
		auto: false,
		value: 0,
		duration: 10,
		format: "",
		theme: "minimal",
	});
	od.update(detail.dataset.statNumberValue);
};

const drawBlueprintBG = (func, direction, obj) => {
	const svgs = obj.el.querySelectorAll("svg.vivus-drawing");
	svgs.forEach((svg) => {
		// console.log(svg);
		const id = svg.id;

		// add a fade in class to the svg
		svg.classList.add("fade-in");

		new Vivus(id, { start: "manual", duration: 400, type: "sync", animTimingFunction: Vivus.EASE }, function (obj) {
			obj.el.classList.add("finished");
		}).play();
	});
};

const revealTextUpwards = (el) => {
	let tl = gsap.timeline({ defaults: { duration: 1 } });
	tl.from(el, {
		y: 50, // Less distance to travel
		duration: 1.25,
		delay: 0.5,
		stagger: 0.1,
		ease: "back.out(1.7)", // Custom easing for subtle movement
		opacity: 0,
	});
};

const callAnimMap = {
	"fade-up": fadeUp,
	"stat-fade-up": statFadeUp,
	"quick-odometer": quickOdometer,
	"draw-blueprint-bg": drawBlueprintBG,
};
